// AXIOS
import axios from "axios";

// api url
import { apiToken, apiUrl_forOrders, apiUrl_forOrders2 } from "./constants";

// cancel token
const CancelToken = axios.CancelToken;

// get orders list
export let cancelGetOrdersApi;
export async function getOrders(userToken, query) {
    const ordersData = await axios.get(apiUrl_forOrders + query, {
        headers: {
            Authorization: `Bearer ${userToken ?? ""}`,
            "Api-Token": apiToken,
            "Access-Token": "",
        },
        cancelToken: new CancelToken(function executor(c) {
            // An executor function receives a cancel function as a parameter
            cancelGetOrdersApi = c;
        }),
    });
    return ordersData;
}

// get order details
export let cancelGetOrderDetailsApi;
export async function getOrderDetails(token, orderId) {
    if (token && orderId) {
        const ordersData = await axios.get(
            apiUrl_forOrders2 + `/detail/${orderId}`,
            {
                headers: {
                    Authorization: `Bearer ${token ?? ""}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetOrderDetailsApi = c;
                }),
            }
        );
        return ordersData;
    } else {
        console.log("Please add required paramaters");
    }
}

// get order details
export let cancelValidatePaymentApi;
export async function validatePaymentApi({ _order_id, _order_token }) {
    if (_order_id && _order_token) {
        const checkValidity = await axios.get(apiUrl_forOrders2 + `validate/payment/${_order_id}/${_order_token}`,
            {
                headers: {
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelValidatePaymentApi = c;
                }),
            }
        );
        return checkValidity;
    } else {
        console.log("Please add required paramaters");
    }
}
